import {bottomBarModuleName} from 'modules/bottom-bar/slice';
import {IBottomBarState} from 'modules/bottom-bar/types';
import {TAppRootState} from 'core/redux/types';

const select = (state: TAppRootState): IBottomBarState => {
    return state[bottomBarModuleName];
};

export const selectBottomBarActiveItem = (state: TAppRootState): IBottomBarState['activeItem'] =>
    select(state).activeItem;

export const selectBottomBarPrevActiveItem = (state: TAppRootState): IBottomBarState['prevActiveItem'] =>
    select(state).prevActiveItem;
